import { push } from 'connected-react-router';
import store from 'configureStore';
import { Actions as userActions } from '../reducers/user';
import { toastr } from 'react-redux-toastr';

export const parseJSON = (response: Response): Promise<Response> => response.json();

const logoutOnIdle = () => {
  if (store.getState().user.isAuthenticated) {
    store.dispatch(userActions.logout());
    toastr.warning('Сеанс был завершен', '');
  }
};

const timeout = 115 * 1000 * 60;

let idleTimer: any;

const timerStart = () => {
  idleTimer = setTimeout(logoutOnIdle, timeout);
};

const timerReset = () => {
  clearTimeout(idleTimer);
  timerStart();
}

// export const checkStatus = (response: Response): Promise<Response> => {
//   if (response.status >= 200 && response.status < 300) {
//     return Promise.resolve(response);
//   }
//   if (response.status >= 500) {
//     // toastr.error('Непредвиденная ошибка сервера');
//   }
//   const error = new Error(String(response.status) || response.statusText);
//   throw error;
// };

const commonOptions = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

// TODO: rewrite
export const fileDownload = (url: string, options: object) => {
  timerReset();
  return fetch(url, options)
    // .then(checkStatus)
    .then((response: any) => {
      if (response.status === 401 && !url.startsWith('/api/login')) {
        store.dispatch(userActions.logoutSuccess());
        store.dispatch(push('/auth'));
        toastr.warning('Ваша сессия истекла. Повторите вход', '');
        return { success: false, error: 'Ваша сессия истекла. Повторите вход' };
      }
      if (response.status === 404) {
        return { success: false, error: 'Непредвиденная ошибка сервера' };
      }
      if (response.status >= 500) {
        toastr.error('Непредвиденная ошибка сервера', '');
        return { success: false, error: 'Непредвиденная ошибка сервера' };
      }
      return response.blob();
    })
    // .then(parseJSON)
    // .then(data => ({ data }));
    .catch((err) => {
      console.log('err: ', err);
    });
};

export const fetchFile = (url: string) => (body: object) =>
  fileDownload(url, {
    ...commonOptions,
    method: 'put',
    body: JSON.stringify(body),
  });

export const request = (url: string, options: object) => {
  timerReset();
  return fetch(url, options)
    // .then(checkStatus)
    .then((response: Response) => {
      if (response.status === 401 && !url.startsWith('/api/login')) {
        store.dispatch(userActions.logoutSuccess());
        store.dispatch(push('/auth'));
        toastr.warning('Ваша сессия истекла. Повторите вход', '');
        return { success: false, error: 'Ваша сессия истекла. Повторите вход' };
      }
      if (response.status === 403) {
        return { success: false, error: 'Нет прав на выполнение операции' };
      }
      if (response.status === 404) {
        return { success: false, error: 'Непредвиденная ошибка сервера' };
      }
      if (response.status >= 500) {
        toastr.error('Непредвиденная ошибка сервера', '');
        return { success: false, error: 'Непредвиденная ошибка сервера' };
      }
      return response.json();
    })
    // .then(parseJSON)
    // .then(data => ({ data }));
    .catch((err) => {
      console.log('err: ', err);
      return { success: false, error: 'Нет ответа сервера' };
    });
};

export const trustedRequest = (url: string) =>
  request(url, {
    ...commonOptions,
  });

export const putRequest = (url: string) => (body: object) =>
  request(url, {
    ...commonOptions,
    method: 'put',
    body: JSON.stringify(body),
  });

export const delRequest = (url: string) =>
  request(url, {
    credentials: 'same-origin',
    method: 'delete',
  });

export const postRequest = (url: string) => (body: object) =>
  request(url, {
    ...commonOptions,
    method: 'post',
    body: JSON.stringify(body),
  });
